import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';
import { fontSize } from 'app/shared/styles/_fontsize';
import type { ComponentType } from 'react';

import Animation from 'app/shared/modules/Animation';

export const NotFoundPage = styled.div`
  text-align: center;
  margin-top: 42px;

  @media ${viewports['lg-and-up']} {
    margin-top: 0;
    text-align: left;
    min-height: 650px;
  }
`;

export const NotFoundPageLeft = styled.div`
  width: 100%;
  display: inline-block;
  text-align: center;
  margin-top: 0;

  @media ${viewports['lg-and-up']} {
    text-align: left;
    width: 60%;
    margin-top: 60px;
  }
`;

export const NotFoundPageAutocompleteWrapper = styled.div`
  max-width: 500px;
  margin: 0 auto 24px auto;
  height: 40px;

  @media ${viewports['lg-and-up']} {
    max-width: inherit;
    margin: 0 auto 24px auto;
    height: 44px;
  }

  /* Fix icon alignment in AutocompleteV2 */
  .AutoCompleteV2-container {
    position: relative;
  }

  .AutocompleteV2-input {
    position: relative;
  }

  .AutocompleteV2-input-container {
    position: relative;
  }

  .AutocompleteV2-search-icon {
    position: absolute;
    top: 12px;
    left: 10px;

    @media (min-width: 768px) {
      top: 14px;
      left: 10px;
    }
  }

  .Input-element {
    padding-left: 30px;
  }

  .AutocompleteV2-dropdown {
    position: absolute;
    top: 0;
    margin: 0;
  }
`;

export const NotFoundPageSubColumn = styled.div`
  text-align: center;
  width: 100%;
  vertical-align: top;
  line-height: ${fontSize['$line-height-md']};

  @media ${viewports['lg-and-up']} {
    display: inline-block;
    width: 50%;
    text-align: left;
  }
`;

export const NotFoundPageHouse: ComponentType<React.ComponentProps<typeof Animation>> = styled(Animation)`
  width: 288px;
  height: 246px;
  margin: 0 auto;
  left: 0;
  right: 0;

  @media ${viewports['lg-and-up']} {
    height: 440px;
    left: auto;
    position: absolute;
    right: -60px;
    top: 0;
    width: 517px;
  }
`;
